import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-widget-title',
  templateUrl: './widget-title.component.html',
  styleUrls: ['./widget-title.component.scss']
})
export class WidgetTitleComponent implements OnInit {
  @Input('widgetTitle') public title: string;

  constructor() { }

  ngOnInit(): void {
  }

}
